var map = {
	"./coulrophobia.png": "8aa3",
	"./hexRuin.png": "2b8c",
	"./huntressLullaby.png": "fcd6",
	"./oppression.png": "59a2",
	"./unnervingPresence.png": "77ad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "85c5";